import { createAction } from "@reduxjs/toolkit";
export const FETCH_USER_CALL_REPORT = 'FETCH_USER_CALL_REPORT';
export const fetchUserCallReportAction = createAction(FETCH_USER_CALL_REPORT);